import React, { Fragment, useState, useEffect, useRef } from "react";
import Breadcrumb from "../../../components/common/breadcrumb";
import { Modal, Container, Row, Col, Card, Form, Button, InputGroup } from "react-bootstrap";
import { UserDropdown, CentreDropdown } from "../../../components/dropdown";
import DataTables from "../commonComponent/DataTable/DataTables";
import ToolTip from "../commonComponent/ToolTip";
import paginationFactory from 'react-bootstrap-table2-paginator';
import SweetAlert from 'sweetalert2';
import { v4 as uuidv4 } from 'uuid';
import { URL_Start } from '../../../constant';
import axios from 'axios';
import { useHistory } from "react-router-dom";
import { set } from "lodash";

var glblmodality = [];
var glbldata = [];
var glbModality = [];
const AddCoupon = () => {
    const history = useHistory();
    const [ruleName, setRuleName] = useState("");
    const [ruleDescription, setRuleDescription] = useState("");
    const [displayDescription, setDisplayDescription] = useState("");
    const [minCartValue, setMinCartValue] = useState("");
    const [applicabilityFrom, setApplicabilityFrom] = useState("");
    const [applicabilityTo, setApplicabilityTo] = useState("");
    const [couponName, setCouponName] = useState("");
    const [selectedCustomerType, setSelectedCustomerType] = useState([]);
    const [selectedCustomerProfile, setSelectedCustomerProfile] = useState([]);
    const [selectedCustomerChannel, setSelectedCustomerChannel] = useState([]);
    const [selectedGender, setSelectedGender] = useState([]);
    const [selectedmodality, setSelectedmodality] = useState([]);
    const [selecteditems, setSelecteditems] = useState([]);
    const [selectedusage, setSelectedusage] = useState([]);
    const [couponCount, setCouponCount] = useState("");
    const [selectedType, setSelectedType] = useState("");
    const [selectedCartType, setSelectedCartType] = useState("");
    const [selectedProduct, setSelectedProduct] = useState([]);
    const [selectedBuyX, setSelectedBuyX] = useState([]);
    const [selectedBuyY, setSelectedBuyY] = useState([]);
    const [ageFrom, setAgeFrom] = useState("");
    const [ageTo, setAgeTo] = useState("");
    const [cartValue, setCartValue] = useState("");
    const [uptoCartValue, setUptoCartValue] = useState("");
    const [isActive, setIsActive] = useState(true);
    const [locationCustomerType, setLocationCustomerType] = useState([]);
    const [crntPageNO, setCrntPageNO] = useState(0);
    const [crntPageNO1, setCrntPageNO1] = useState(0);
    const [crntPageNO2, setCrntPageNO2] = useState(0);
    const [selectedcategory, setSelectedCategory] = useState([]);
    const [blackoutFrom, setBlackoutFrom] = useState("");
    const [blackoutTo, setBlackoutTo] = useState("");
    const [dateRanges, setDateRanges] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [searchQueryCentres, setSearchQueryCentres] = useState("");
    const [showItemsModal, setShowItemsModal] = useState(false);
    const [customerTypeOptions, setCustomerTypeOptions] = useState([]);
    const [locationTypeOptions, setLocationTypeOptions] = useState([]);
    const [selectedCentreListOptions, setSelectedCentreListOptions] = useState([]);
    const [customertypeids, setCustomerTypeIds] = useState("");
    const [selectedCentreList, setSelectedCentreList] = useState([]);
    const [genderOptions, setGenderOptions] = useState([]);
    const [customerChannelOptions, setCustomerChannelOptions] = useState([]);
    const [customerProfileOptions, setCustomerProfileOptions] = useState([]);
    const [usageOptions, setUsageOptions] = useState([]);
    const [selecttypeOptions, setSelectTypeOptions] = useState([]);
    const [categoryOptions, setCategoryOptions] = useState([]);
    const [globalmodality, setGlobalModality] = useState([]);
    const [modalityOptions, setModalityOptions] = useState([]);
    const [itemsOptions, setItemsOptions] = useState([]);
    const [selecttypevalue, setSelectTypeValue] = useState("");
    const [showonui, setShowonUI] = useState("1");
    const [isnoshow, setIsNoShow] = useState(false);
    const [isyeshow, setIsyesShow] = useState(true);
    const [LoginId, setLoginId] = useState(localStorage.LoggedInUser == undefined ? "" : localStorage.LoggedInUser);
    const [customerType, setCustomerType] = useState("1");
    useEffect(() => {
        if (localStorage.getItem("CouponId") == "" || localStorage.getItem("CouponId") == null || localStorage.getItem("CouponId") == undefined || localStorage.getItem("CouponId") == "0") {
            GetPromotionsCentreTypeAndGenderAndChannel("1");
        }
        else {
            GetPromotionsCentreTypeAndGenderAndChannel("1");
            GetPromotionsCentreTypeAndGenderAndChannel("2");
            GetPromotionsCentreTypeAndGenderAndChannel("3");
            GetPromotionsCentreTypeAndGenderAndChannel("4");
            GetPromotionsCentreTypeAndGenderAndChannel("5");
            GetPromotionsCentreTypeAndGenderAndChannel("6");
            GetEditPromotionData(localStorage.getItem("CouponId"));
        }

        return () => {
            setRuleName("");
            setRuleDescription("");
            setAgeFrom("");
            setAgeTo("");
            setMinCartValue("");
            setApplicabilityFrom("");
            setApplicabilityTo("");
            setCouponName("");
            setCouponCount("");
            setDisplayDescription("");
            setIsActive(true);
            setDateRanges([]);
            setBlackoutFrom("");
            setBlackoutTo("");
            setCustomerTypeIds("");
            setSelectedCustomerType([]);
            setCustomerTypeOptions([]);
            setLocationCustomerType([]);
            setLocationTypeOptions([]);
            setSelectedCentreList([]);
            setSelectedCentreListOptions([]);
            setSelectedGender([]);
            setGenderOptions([]);
            setSelectedCustomerChannel([]);
            setCustomerChannelOptions([]);
            setSelectedCustomerProfile([]);
            setCustomerProfileOptions([]);
            setSelectedCategory([]);
            setCategoryOptions([]);
            glbModality = [];
            setSelectedmodality([]);
            setModalityOptions([]);
            setSelecteditems([]);
            setItemsOptions([]);
            setSelectedusage([]);
            setUsageOptions([]);
            setSelectedType("");
            setSelectTypeValue("");
            setSelectedCartType("");
            setCartValue("");
            setUptoCartValue("");
            setSelectedProduct([]);
            setSelectedBuyX([]);
            setSelectedBuyY([]);
            setSelectTypeOptions([]);
            localStorage.removeItem("CouponId");
        }
    }, [])


    useEffect(() => {
        if (localStorage.getItem("CouponId") != "") {
            if (localStorage.getItem("CouponId") != null) {
                if (localStorage.getItem("CouponId") != undefined) {
                    if (localStorage.getItem("CouponId") != "0") {
                        if (customerTypeOptions.length > 0) {
                            if (glbldata.zcustomertype && Array.isArray(glbldata.zcustomertype)) {
                                const selectedValues = glbldata.zcustomertype.map((item) => item.value);
                                const matchedCustomerTypes = customerTypeOptions.filter((option) => selectedValues.includes(option.value));
                                setSelectedCustomerType(matchedCustomerTypes);
                                var TypeOptrows = "";
                                matchedCustomerTypes.map((item, index) => {
                                    TypeOptrows += matchedCustomerTypes.length == parseInt(parseInt(index) + 1) ? item.value : item.value + ","
                                    return TypeOptrows;
                                });
                                setCustomerTypeIds(TypeOptrows);
                                GetPromotionsRegions(TypeOptrows);
                            }
                        }
                    }
                }
            }
        }
    }, [customerTypeOptions, glbldata])

    useEffect(() => {
        if (localStorage.getItem("CouponId") != "") {
            if (localStorage.getItem("CouponId") != null) {
                if (localStorage.getItem("CouponId") != undefined) {
                    if (localStorage.getItem("CouponId") != "0") {
                        if (locationTypeOptions.length > 0) {
                            if (glbldata.zregion && Array.isArray(glbldata.zregion)) {
                                const selectedValues = glbldata.zregion.map((item) => item.value);
                                const matchedCustomerTypes = locationTypeOptions.filter((option) => selectedValues.includes(option.value));
                                setLocationCustomerType(matchedCustomerTypes);
                                const TypeOptL = [];
                                matchedCustomerTypes.map((item) => {
                                    const TypeOptrows = {
                                        'Id': item.value
                                    }
                                    return TypeOptL.push(TypeOptrows);
                                });
                                GetPromotionsCentres(TypeOptL);
                            }
                        }
                    }
                }
            }
        }
    }, [locationTypeOptions, glbldata])

    useEffect(() => {
        if (localStorage.getItem("CouponId") != "") {
            if (localStorage.getItem("CouponId") != null) {
                if (localStorage.getItem("CouponId") != undefined) {
                    if (localStorage.getItem("CouponId") != "0") {
                        if (selectedCentreListOptions.length > 0) {
                            if (glbldata.zcentre && Array.isArray(glbldata.zcentre)) {
                                const selectedValues = glbldata.zcentre.map((item) => item.value);
                                const matchedCustomerTypes = selectedCentreListOptions.filter((option) => selectedValues.includes(option.value));
                                setSelectedCentreList(matchedCustomerTypes);
                                GetCategoryModalities();
                            }
                        }
                    }
                }
            }
        }
    }, [selectedCentreListOptions, glbldata])

    useEffect(() => {
        if (localStorage.getItem("CouponId") != "") {
            if (localStorage.getItem("CouponId") != null) {
                if (localStorage.getItem("CouponId") != undefined) {
                    if (localStorage.getItem("CouponId") != "0") {
                        if (genderOptions.length > 0) {
                            if (glbldata.zgender && Array.isArray(glbldata.zgender)) {
                                const selectedValues = glbldata.zgender.map((item) => item.value);
                                const matchedCustomerTypes = genderOptions.filter((option) => selectedValues.includes(option.value));
                                setSelectedGender(matchedCustomerTypes);
                            }
                        }
                    }
                }
            }
        }
    }, [genderOptions, glbldata])

    useEffect(() => {
        if (localStorage.getItem("CouponId") != "") {
            if (localStorage.getItem("CouponId") != null) {
                if (localStorage.getItem("CouponId") != undefined) {
                    if (localStorage.getItem("CouponId") != "0") {
                        if (customerChannelOptions.length > 0) {
                            if (glbldata.zcustomerchannel && Array.isArray(glbldata.zcustomerchannel)) {
                                const selectedValues = glbldata.zcustomerchannel.map((item) => item.value);
                                const matchedCustomerTypes = customerChannelOptions.filter((option) => selectedValues.includes(option.value));
                                setSelectedCustomerChannel(matchedCustomerTypes);
                            }
                        }
                    }
                }
            }
        }
    }, [customerChannelOptions, glbldata])

    useEffect(() => {
        if (localStorage.getItem("CouponId") != "") {
            if (localStorage.getItem("CouponId") != null) {
                if (localStorage.getItem("CouponId") != undefined) {
                    if (localStorage.getItem("CouponId") != "0") {
                        if (customerProfileOptions.length > 0) {
                            if (glbldata.zcustomerprofile && Array.isArray(glbldata.zcustomerprofile)) {
                                const selectedValues = glbldata.zcustomerprofile.map((item) => item.value);
                                const matchedCustomerTypes = customerProfileOptions.filter((option) => selectedValues.includes(option.value));
                                if (matchedCustomerTypes.length == 0) {
                                    setCustomerType("1");
                                }
                                else {
                                    setSelectedCustomerProfile(matchedCustomerTypes);
                                    setCustomerType("0");
                                }
                            }
                        }
                    }
                }
            }
        }
    }, [customerProfileOptions, glbldata])

    useEffect(() => {
        if (localStorage.getItem("CouponId") != "") {
            if (localStorage.getItem("CouponId") != null) {
                if (localStorage.getItem("CouponId") != undefined) {
                    if (localStorage.getItem("CouponId") != "0") {
                        if (categoryOptions.length > 0) {
                            if (glbldata.zcategory && Array.isArray(glbldata.zcategory)) {
                                const selectedValues = glbldata.zcategory.map((item) => item.value);
                                const matchedCustomerTypes = categoryOptions.filter((option) => selectedValues.includes(option.value));
                                setSelectedCategory(matchedCustomerTypes);
                                var arr = [];
                                arr = glbModality.filter(d =>
                                    matchedCustomerTypes.some(cat => cat.value === d.Id)
                                );
                                var transformedArr = arr.map((item, index) => ({
                                    value: parseInt(parseInt(index) + 1).toString(),//item.Id,
                                    label: item.ModalityName
                                }));
                                setModalityOptions(transformedArr);
                            }
                        }
                    }
                }
            }
        }
    }, [categoryOptions, glbldata])

    useEffect(() => {
        if (localStorage.getItem("CouponId") != "") {
            if (localStorage.getItem("CouponId") != null) {
                if (localStorage.getItem("CouponId") != undefined) {
                    if (localStorage.getItem("CouponId") != "0") {
                        if (modalityOptions.length > 0) {
                            if (glbldata.zmodality && Array.isArray(glbldata.zmodality)) {
                                const selectedValues = glbldata.zmodality.map((item) => item.value);
                                const matchedCustomerTypes = modalityOptions.filter((option) => selectedValues.includes(option.value));
                                setSelectedmodality(matchedCustomerTypes);
                                getmodalityitems(matchedCustomerTypes);
                            }
                        }
                    }
                }
            }
        }
    }, [modalityOptions, glbldata])

    useEffect(() => {
        if (localStorage.getItem("CouponId") != "") {
            if (localStorage.getItem("CouponId") != null) {
                if (localStorage.getItem("CouponId") != undefined) {
                    if (localStorage.getItem("CouponId") != "0") {
                        if (itemsOptions.length > 0) {
                            if (glbldata.zitems && Array.isArray(glbldata.zitems)) {
                                const selectedValues = glbldata.zitems.map((item) => item.value);
                                const matchedCustomerTypes = itemsOptions.filter((option) => selectedValues.includes(option.value));
                                setSelecteditems(matchedCustomerTypes);
                            }
                        }
                    }
                }
            }
        }
    }, [itemsOptions, glbldata])

    useEffect(() => {
        if (localStorage.getItem("CouponId") != "") {
            if (localStorage.getItem("CouponId") != null) {
                if (localStorage.getItem("CouponId") != undefined) {
                    if (localStorage.getItem("CouponId") != "0") {
                        if (usageOptions.length > 0) {
                            if (usageOptions && Array.isArray(usageOptions)) {
                                setSelectedusage(usageOptions.filter((d) => d.value == glbldata.Usage));
                            }
                        }
                    }
                }
            }
        }
    }, [usageOptions, glbldata])

    useEffect(() => {
        if (localStorage.getItem("CouponId") != "") {
            if (localStorage.getItem("CouponId") != null) {
                if (localStorage.getItem("CouponId") != undefined) {
                    if (localStorage.getItem("CouponId") != "0") {
                        if (selecttypeOptions.length > 0) {
                            if (selecttypeOptions && Array.isArray(selecttypeOptions)) {
                                setSelectedType(selecttypeOptions.filter((d) => d.value == glbldata.CouponType));
                                setSelectTypeValue(glbldata.CouponType);
                            }
                        }
                    }
                }
            }
        }
    }, [selecttypeOptions, glbldata])

    useEffect(() => {
        if (localStorage.getItem("CouponId") != "") {
            if (localStorage.getItem("CouponId") != null) {
                if (localStorage.getItem("CouponId") != undefined) {
                    if (localStorage.getItem("CouponId") != "0") {
                        if (selecttypevalue != "") {
                            if (glbldata.CouponType == "1") {
                                setSelectedCartType(glbldata.SelectedCouponType);
                                setCartValue(glbldata.CartValue);
                                setUptoCartValue(glbldata.UptoCartValue);
                                setSelectedProduct([]);
                                setSelectedBuyX([]);
                                setSelectedBuyY([]);
                            }
                            if (glbldata.CouponType == "2") {
                                if (glbldata.zselectproduct == null) { setSelectedProduct([]); }
                                else {
                                    if (itemsOptions.length > 0) {
                                        if (glbldata.zselectproduct && Array.isArray(glbldata.zselectproduct)) {
                                            const selectedValues = glbldata.zselectproduct.map((item) => item.value);
                                            let matchedCustomerTypes = itemsOptions.filter((option) => selectedValues.includes(option.value));
                                            setSelectedProduct(matchedCustomerTypes);
                                        }
                                    }
                                }
                                setSelectedCartType("");
                                setCartValue("");
                                setUptoCartValue("");
                                setSelectedBuyX([]);
                                setSelectedBuyY([]);
                            }
                            if (glbldata.CouponType == "3") {
                                if (glbldata.zbuyx == null) { setSelectedBuyX([]); }
                                else {
                                    if (itemsOptions.length > 0) {
                                        if (glbldata.zbuyx && Array.isArray(glbldata.zbuyx)) {
                                            const selectedValues = glbldata.zbuyx.map((item) => item.value);
                                            const matchedCustomerTypes = itemsOptions.filter((option) => selectedValues.includes(option.value));
                                            setSelectedBuyX(matchedCustomerTypes);
                                        }
                                    }
                                }
                                if (glbldata.zgety == null) { setSelectedBuyY([]); }
                                else {
                                    if (itemsOptions.length > 0) {
                                        if (glbldata.zgety && Array.isArray(glbldata.zgety)) {
                                            const selectedValues = glbldata.zgety.map((item) => item.value);
                                            const matchedCustomerTypes = itemsOptions.filter((option) => selectedValues.includes(option.value));
                                            setSelectedBuyY(matchedCustomerTypes);
                                        }
                                    }
                                }
                                setSelectedCartType("");
                                setCartValue("");
                                setUptoCartValue("");
                                setSelectedProduct([]);
                            }
                        }
                    }
                }
            }
        }
    }, [glbldata, selecttypevalue, itemsOptions])

    const handleRemoveItem = (index) => { setSelecteditems((prevItems) => prevItems.filter((_, i) => i !== index)); };
    const handleShow = () => setShowModal(true);
    const handleRemoveCentre = (index) => { setSelectedCentreList((prevCentres) => prevCentres.filter((_, i) => i !== index)); };
    const handleRemoveDateRange = (id) => { setDateRanges((prevRanges) => prevRanges.filter(range => range.id !== id)); };
    const handleRefresh = () => { window.location.reload(false); };
    const handleitemsChange = (newitems) => { setSelecteditems(newitems); };
    const handleButtonClick = () => { handleShow(); };
    const handleButtonClick2 = () => { setShowItemsModal(true); };
    const handleCopyCoupon = () => {
        if (couponName.trim() !== "") {
            navigator.clipboard.writeText(couponName);
            SweetAlert.fire("Coupon code copied!");
        } else {
            SweetAlert.fire("Please enter a coupon name first.");
        }
    };
    const handleAddDateRange = () => {
        if (!blackoutFrom) {
            SweetAlert.fire("Please enter blackout from date");
            return false;
        }
        if (!blackoutTo) {
            SweetAlert.fire("Please enter blackout to date");
            return false;
        }
        if (!applicabilityFrom) {
            SweetAlert.fire("Please enter applicability from date first");
            return false;
        }
        if (!applicabilityTo) {
            SweetAlert.fire("Please enter applicability to date first");
            return false;
        }
        if ((blackoutFrom < applicabilityFrom) || (blackoutTo < applicabilityFrom)) {
            SweetAlert.fire("Blackout from date or to date cannot be less than applicability from date");
            return false;
        }
        if ((blackoutFrom > applicabilityTo) || (blackoutTo > applicabilityTo)) {
            SweetAlert.fire("Blackout from date or to date cannot be greater than applicability to date");
            return false;
        }
        const hasSameFromTo = dateRanges.some(range => range.from === blackoutFrom && range.to === blackoutTo);
        if (hasSameFromTo) {
            SweetAlert.fire("A date range with the same from and to date already exists.");
            return false;
        }
        if (blackoutFrom && blackoutTo) {
            setDateRanges([...dateRanges, { id: uuidv4(), from: blackoutFrom, to: blackoutTo }]); // Adding a unique id
            setBlackoutFrom("");
            setBlackoutTo("");
        }
    };
    const idFormatter = (cellData, rowData, rowIndex, extraData) => {
        return <React.Fragment>
            <span>{crntPageNO + rowIndex + 1}</span>
        </React.Fragment>
    }
    const idFormatter1 = (cellData, rowData, rowIndex, extraData) => {
        return <React.Fragment>
            <span>{crntPageNO1 + rowIndex + 1}</span>
        </React.Fragment>
    }
    const idFormatter2 = (cellData, rowData, rowIndex, extraData) => {
        return <React.Fragment>
            <span>{crntPageNO2 + rowIndex + 1}</span>
        </React.Fragment>
    }
    const paginationOptions = {
        sizePerPage: 5,
        showTotal: false,
        firstPageText: 'First',
        prePageText: 'Back',
        nextPageText: 'Next',
        lastPageText: 'Last',
        onPageChange: (page, sizePerPage) => { setCrntPageNO(((page - 1) * sizePerPage)); }
    };
    const paginationOptions1 = {
        sizePerPage: 5,
        showTotal: false,
        firstPageText: 'First',
        prePageText: 'Back',
        nextPageText: 'Next',
        lastPageText: 'Last',
        onPageChange: (page, sizePerPage) => { setCrntPageNO1(((page - 1) * sizePerPage)); }
    };
    const paginationOptions2 = {
        sizePerPage: 5,
        showTotal: false,
        firstPageText: 'First',
        prePageText: 'Back',
        nextPageText: 'Next',
        lastPageText: 'Last',
        onPageChange: (page, sizePerPage) => { setCrntPageNO2(((page - 1) * sizePerPage)); }
    };
    const columns = [
        { dataField: "id", text: "Id", editable: false, formatter: idFormatter },
        { dataField: "name", text: "Items", editable: false },
        {
            dataField: "action",
            text: "Action",
            editable: false,
            formatter: (cell, row) => (
                <ToolTip
                    title="Delete"
                    placement="top"
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        handleRemoveItem(row.id);
                    }}
                    linkId={`Delete-${row.id}`}
                    faName="fa fa-trash mr-2"
                />
            ),
        },
    ];
    const columns2 = [
        { dataField: "id", text: "Id", editable: false, formatter: idFormatter1 },
        {
            text: 'Blackout Date From',
            dataField: 'from',
            editable: false,
        },
        {
            text: 'Blackout Date To',
            dataField: 'to',
            editable: false,
        },
        {
            text: 'Action',
            dataField: 'action',
            formatter: (cell, row) => (
                <ToolTip
                    title="Delete"
                    placement="top"
                    onClick={(e) => {
                        console.log("Deleting ID:", row.id);
                        handleRemoveDateRange(row.id);
                        e.preventDefault();
                        e.stopPropagation();
                    }}
                    linkId={`Delete-${row.id}`}
                    faName="fa fa-trash mr-2"
                />
            ),
        },
    ];
    const columns3 = [
        { dataField: "id", text: "Id", editable: false, formatter: idFormatter2 },
        { dataField: "name", text: "Centres", editable: false },
        {
            dataField: "action",
            text: "Action",
            editable: false,
            formatter: (cell, row) => (
                <ToolTip
                    title="Delete"
                    placement="top"
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        handleRemoveCentre(row.id);
                    }}
                    linkId={`Delete-${row.id}`}
                    faName="fa fa-trash mr-2"
                />
            ),
        },
    ];
    // Items Filter on Modal//
    const tableData = selecteditems.map((item, index) => ({
        id: index,
        name: item.label,
        description: item.value
    }));
    const filteredData = tableData.filter((row) =>
        String(row.name).toLowerCase().includes(String(searchQuery).toLowerCase())
    );
    // Items Filter on Modal//
    // Centres Filter on Modal//
    const tableDataCentres = selectedCentreList.map((item, index) => ({
        id: index,
        name: item.label,
        description: item.value
    }));
    const filteredTableDataCentres = tableDataCentres.filter((row) =>
        String(row.name).toLowerCase().includes(String(searchQueryCentres).toLowerCase())
    );
    // Centres Filter on Modal//
    const GetPromotionsCentreTypeAndGenderAndChannel = async (flag) => {
        try {
            let url = URL_Start + 'promotions/getallpromotionsdata/' + flag
            await axios.get(url).then((response) => {
                const data = response.data;
                if (data.Success) {
                    if (data.Data == null || data.Data == undefined || data.Data == "") { }
                    else {
                        let ds = data.Data;
                        const TypeOptionDs1 = [];

                        ds.map((option) => {
                            const TypeOptions1 = {
                                'label': option.Value,
                                'value': option.Id,
                                'disabled': false
                            }
                            return TypeOptionDs1.push(TypeOptions1);
                        });
                        if (flag == "1") {
                            setCustomerTypeOptions(TypeOptionDs1);
                            //This logic is for by default select//
                            setSelectedCustomerType(TypeOptionDs1);
                            var TypeOptrows = "";
                            TypeOptionDs1.map((item, index) => {
                                TypeOptrows += TypeOptionDs1.length == parseInt(parseInt(index) + 1) ? item.value : item.value + ","
                                return TypeOptrows;
                            });
                            setCustomerTypeIds(TypeOptrows);
                            GetPromotionsRegions(TypeOptrows);
                            //This logic is for by default select//
                        }
                        if (flag == "2") { setGenderOptions(TypeOptionDs1); }
                        if (flag == "3") {
                            setCustomerChannelOptions(TypeOptionDs1);
                            //This logic is for by default select//
                            setSelectedCustomerChannel(TypeOptionDs1);
                            GetPromotionsCentreTypeAndGenderAndChannel("4"); //customer profile
                            //This logic is for by default select//
                        }
                        if (flag == "4") {
                            setCustomerProfileOptions(TypeOptionDs1);
                            GetPromotionsCentreTypeAndGenderAndChannel("5"); //usage 
                        }
                        if (flag == "5") { setUsageOptions(TypeOptionDs1); }
                        if (flag == "6") { setSelectTypeOptions(TypeOptionDs1); }
                    }
                }
                else {
                    if (data.Data == null || data.Data == undefined || data.Data == "") { SweetAlert.fire("Some issue occured.Try again or check db logs"); }
                    else { SweetAlert.fire("Error is: " + data.Data); }
                    return false;
                }
            }).catch(function (error) { if (error.response) { ErrorFunction(error.response.status); } });
        }
        catch (error) { SweetAlert.fire({ title: "Server Inaccessible!", text: "You may not be connected to a network or Unable to connect to a server", icon: "error" }); }
    }
    const ChangeCustomerType = async (options) => {
        if (options.length == "0" || options == [] || options == null) { ClearFields("1"); }
        else {
            setSelectedCustomerType(options);
            var TypeOptrows = "";
            options.map((item, index) => {
                TypeOptrows += options.length == parseInt(parseInt(index) + 1) ? item.value : item.value + ","
                return TypeOptrows;
            });
            setCustomerTypeIds(TypeOptrows);
            GetPromotionsRegions(TypeOptrows);
        }
    }
    const GetPromotionsRegions = async (ids) => {
        try {
            let url = URL_Start + 'promotions/getpromotionsregions/' + ids
            await axios.get(url).then((response) => {
                const data = response.data;
                if (data.Success) {
                    if (data.Data == null || data.Data == undefined || data.Data == "") { }
                    else {
                        let ds = data.Data;
                        const TypeOptionDs1 = [];
                        ds.map((option) => {
                            const TypeOptions1 = {
                                'label': option.Value,
                                'value': option.Id,
                                'disabled': false
                            }
                            return TypeOptionDs1.push(TypeOptions1);
                        });
                        setLocationTypeOptions(TypeOptionDs1);
                    }
                }
                else {
                    if (data.Data == null || data.Data == undefined || data.Data == "") { SweetAlert.fire("Some issue occured.Try again or check db logs"); }
                    else { SweetAlert.fire("Error is: " + data.Data); }
                    return false;
                }
            }).catch(function (error) { if (error.response) { ErrorFunction(error.response.status); } });
        }
        catch (error) { SweetAlert.fire({ title: "Server Inaccessible!", text: "You may not be connected to a network or Unable to connect to a server", icon: "error" }); }
    }
    const ChangeRegion = async (options) => {
        if (options.length == "0" || options == [] || options == null) { ClearFields("2"); }
        else {
            setLocationCustomerType(options);
            const TypeOptL = [];
            options.map((item) => {
                const TypeOptrows = {
                    'Id': item.value
                }
                return TypeOptL.push(TypeOptrows);
            });
            GetPromotionsCentres(TypeOptL);
        }
    }
    const GetPromotionsCentres = async (centrelist) => {
        if (customertypeids == "") { SweetAlert.fire("Customer type not selected. Please refresh and try again."); return false; }
        if (centrelist.length == "0") { SweetAlert.fire("Region not selected. Please refresh and try again."); return false; }
        try {
            const requestOptions = {
                CustomerTypeIds: customertypeids,
                CentreLists: JSON.stringify(centrelist)
            };
            let url = URL_Start + 'promotions/promotionscentres'
            await axios.post(url, requestOptions).then((response) => {
                const data = response.data;
                if (data.Success) {
                    if (data.Data == null || data.Data == undefined || data.Data == "") { }
                    else {
                        let ds = data.Data;
                        const TypeOptionDs1 = [];
                        ds.map((option) => {
                            const TypeOptions1 = {
                                'label': option.Value,
                                'value': option.Id,
                                'disabled': false
                            }
                            return TypeOptionDs1.push(TypeOptions1);
                        });
                        setSelectedCentreListOptions(TypeOptionDs1);
                    }
                }
                else {
                    if (data.Data == null || data.Data == undefined || data.Data == "") { SweetAlert.fire("Some issue occured.Try again or check db logs"); }
                    else { SweetAlert.fire("Error is: " + data.Data); }
                    return false;
                }
            }).catch(function (error) { if (error.response) { ErrorFunction(error.response.status); } });
        }
        catch (error) { SweetAlert.fire({ title: "Server Inaccessible!", text: "You may not be connected to a network or Unable to connect to a server", icon: "error" }); }
    }
    const ChangeCentre = async (options) => {
        if (options.length == "0" || options == [] || options == null) { ClearFields("3"); }
        else {
            setSelectedCentreList(options);
            GetPromotionsCentreTypeAndGenderAndChannel("2"); //gender
            GetCategoryModalities();
        }
    }
    const ChangeGender = async (options) => {
        setSelectedmodality([]);
        setItemsOptions([]);
        setSelecteditems([]);
        if (options.length == "0" || options == [] || options == null) { ClearFields("4"); }
        else {
            setSelectedGender(options);
            GetPromotionsCentreTypeAndGenderAndChannel("3"); //customer channel
        }
    }
    const ChangeCustomerChannel = async (options) => {
        if (options.length == "0" || options == [] || options == null) { ClearFields("5"); }
        else {
            setSelectedCustomerChannel(options);
            GetPromotionsCentreTypeAndGenderAndChannel("4"); //customer profile
            GetPromotionsCentreTypeAndGenderAndChannel("5"); //usage
        }
    }
    const ChangeCustomerProfile = async (options) => {
        if (options.length == "0" || options == [] || options == null) { ClearFields("6"); }
        else {
            setSelectedCustomerProfile(options);
            // GetPromotionsCentreTypeAndGenderAndChannel("5"); //usage
        }
    }
    const ChangeUsage = async (options) => {
        if (options.length == "0" || options == [] || options == null) { ClearFields("7"); }
        else {
            setSelectedusage(options);
            GetPromotionsCentreTypeAndGenderAndChannel("6"); //coupon type name
        }
    }
    const ChangeType = async (options) => {
        if (options.length == "0" || options == [] || options == null) { ClearFields("8"); }
        else if (selectedmodality.length == 0) { SweetAlert.fire("Please select modality before proceed."); return false; }
        else {
            setSelectedBuyX([]);
            setSelectedBuyY([]);
            setSelectedCartType("");
            setCartValue("");
            setUptoCartValue("");
            setSelectedProduct([]);
            setSelectedType(options);
            setSelectTypeValue(options.value);
        }
    }
    const GetCategoryModalities = async () => {
        try {
            let url = URL_Start + 'promotions/getpromotionscategoriesandmodalities'
            await axios.get(url).then((response) => {
                const data = response.data;
                if (data.Success) {
                    if (data.Data.promotionscategories == null || data.Data.promotionscategories == undefined || data.Data.promotionscategories == "") { }
                    else {
                        let ds = data.Data.promotionscategories;
                        const TypeOptionDs1 = [];
                        ds.map((option) => {
                            const TypeOptions1 = {
                                'label': option.Value,
                                'value': option.Id,
                                'disabled': false
                            }
                            return TypeOptionDs1.push(TypeOptions1);
                        });
                        setCategoryOptions(TypeOptionDs1);
                    }
                    if (data.Data.promotionsmodality == null || data.Data.promotionsmodality == undefined || data.Data.promotionsmodality == "") { glblmodality = []; setGlobalModality([]); }
                    else { glblmodality = data.Data.promotionsmodality; glbModality = data.Data.promotionsmodality; setGlobalModality(data.Data.promotionsmodality); }
                }
                else {
                    glblmodality = [];
                    setGlobalModality([]);
                    glbModality = [];
                    if (data.Data == null || data.Data == undefined || data.Data == "") { SweetAlert.fire("Some issue occured.Try again or check db logs"); }
                    else { SweetAlert.fire("Error is: " + data.Data); }
                    return false;
                }
            }).catch(function (error) { if (error.response) { ErrorFunction(error.response.status); } });
        }
        catch (error) { SweetAlert.fire({ title: "Server Inaccessible!", text: "You may not be connected to a network or Unable to connect to a server", icon: "error" }); }
    }
    const handlecategoryChange = (newcategory) => {
        if (newcategory.length == "0" || newcategory == [] || newcategory == null) { ClearFields("9"); }
        else {
            setSelectedCategory(newcategory);
            var arr = [];
            arr = globalmodality.filter(d =>
                newcategory.some(cat => cat.value === d.Id)
            );
            var transformedArr = arr.map((item, index) => ({
                value: parseInt(parseInt(index) + 1).toString(),//item.Id,
                label: item.ModalityName
            }));
            setModalityOptions(transformedArr);
        }
    };
    const handlemodalityChange = (newmodality) => {
        setSelecteditems([]); // Items
        if (newmodality.length == "0" || newmodality == [] || newmodality == null) { ClearFields("10"); }
        else {
            setSelectedmodality(newmodality);
            getmodalityitems(newmodality);
        }
    };
    const getmodalityitems = async (newmodality) => {
        if (selectedGender.length == 0) { SweetAlert.fire("Please select gender"); setSelectedmodality([]); return false; }
        if (ageFrom.toString() == "") { SweetAlert.fire("Please enter age from"); setSelectedmodality([]); return false; }
        if (!ageTo) { SweetAlert.fire("Please enter age to"); setSelectedmodality([]); return false; }
        if (newmodality.length == 0) { SweetAlert.fire("Please select modality"); setSelectedmodality([]); return false; }
        try {
            const requestOptions = {
                AgeFrom: ageFrom.toString(),
                AgeTo: ageTo.toString(),
                Genders: JSON.stringify(selectedGender),
                Modalities: JSON.stringify(newmodality)
            };
            let url = URL_Start + 'promotions/modalityitems'
            await axios.post(url, requestOptions).then((response) => {
                const data = response.data;
                if (data.Success) {
                    if (data.Data == null || data.Data == undefined || data.Data == "") { }
                    else {
                        let ds = data.Data;
                        const TypeOptionDs1 = [];
                        ds.map((option) => {
                            const TypeOptions1 = {
                                'label': option.Value,
                                'value': option.Id,
                                'ispackage': (option.IsPackage.toLowerCase() == "true" ? "1" : option.IsPackage.toLowerCase() == "false" ? "0" : option.IsPackage),
                                'disabled': false
                            }
                            return TypeOptionDs1.push(TypeOptions1);
                        });
                        setItemsOptions(TypeOptionDs1);
                    }
                }
                else {
                    setSelectedmodality([]);
                    if (data.Data == null || data.Data == undefined || data.Data == "") { SweetAlert.fire("Some issue occured.Try again or check db logs"); }
                    else { SweetAlert.fire("Error is: " + data.Data); }
                    return false;
                }
            }).catch(function (error) { if (error.response) { ErrorFunction(error.response.status); } });
        }
        catch (error) { SweetAlert.fire({ title: "Server Inaccessible!", text: "You may not be connected to a network or Unable to connect to a server", icon: "error" }); }
    }
    const Changeagefrom = async (e) => {
        if (e.target.value == "") {
            setSelectedmodality([]); // Modality
            setItemsOptions([]); // Items
            setSelecteditems([]); // Items 
            return false;
        }
        else {
            const value = Math.max(0, parseInt(e.target.value));
            setAgeFrom(value);
        }
    }
    const Changeageto = async (e) => {
        if (e.target.value == "") {
            setSelectedmodality([]); // Modality
            setItemsOptions([]); // Items
            setSelecteditems([]); // Items 
            return false;
        }
        else if (e.target.value == "0") {
            SweetAlert.fire("To date cannot be zero.");
            setSelectedmodality([]); // Modality
            setItemsOptions([]); // Items
            setSelecteditems([]); // Items 
            return false;
        }
        else {
            const value = Math.max(0, parseInt(e.target.value));
            setAgeTo(value);
        }
    }
    const Changetodate = async (e) => {
        if (e.target.value < ageFrom) {
            SweetAlert.fire("To date cannot be less than from date.");
            setSelectedmodality([]); // Modality
            setItemsOptions([]); // Items
            setSelecteditems([]); // Items 
            return false;
        }
    }
    const ChangeProduct = async (options) => {
        if (options.length === 0) { setSelectedProduct([]); return false; }
        else {
            setSelectedProduct(options);
        }
    }
    const handleBuyXChange = (options) => {
        if (options.length === 0) { setSelectedBuyX([]); return false; }
        else { setSelectedBuyX(options); }
    };
    const handleBuyYChange = (options) => {
        if (options.length === 0) { setSelectedBuyY([]); return false; }
        else { setSelectedBuyY(options); }
    };
    const ClearFields = async (flag) => {
        if (flag == "1") { // Customer Type
            setSelectedCustomerType([]); // Customer Type
            setCustomerTypeIds(""); // Customer Type
            setLocationCustomerType([]); // Region
            setLocationTypeOptions([]); // Region
            setSelectedCentreList([]); // Centres 
            setSelectedCentreListOptions([]); // Centres 
            setSelectedGender([]); // Gender 
            setGenderOptions([]); // Gender 
            setSelectedCustomerChannel([]); // Customer Channel 
            setCustomerChannelOptions([]); // Customer Channel 
            setCustomerProfileOptions([]); // Customer Profile 
            setSelectedCustomerProfile([]); // Customer Profile 
            setCustomerType("1"); // Customer Type
            setUsageOptions([]); // Usage
            setSelectedusage([]); // Usage
            setSelectedType([]); // Select Type   
            setSelectTypeValue(""); // Select Type Flag
            setSelectTypeOptions([]); // Select Type
            setCategoryOptions([]); // Category
            setSelectedCategory([]); // Category
            setSelectedmodality([]); // Modality
            setModalityOptions([]); // Modality
            setItemsOptions([]); // Items
            setSelecteditems([]); // Items
            setSelectedProduct([]); //Select Type Options
            setSelectedBuyX([]); //Select Type Options
            setSelectedBuyY([]); //Select Type Options
        }
        if (flag == "2") { // Region
            setLocationCustomerType([]); // Region
            setSelectedCentreList([]); // Centres 
            setSelectedCentreListOptions([]); // Centres 
            setSelectedGender([]); // Gender 
            setGenderOptions([]); // Gender 
            setSelectedCustomerChannel([]); // Customer Channel 
            setCustomerChannelOptions([]); // Customer Channel 
            setCustomerProfileOptions([]); // Customer Profile 
            setSelectedCustomerProfile([]); // Customer Profile 
            setCustomerType("1"); // Customer Type
            setUsageOptions([]); // Usage
            setSelectedusage([]); // Usage
            setSelectedType([]); // Select Type   
            setSelectTypeValue(""); // Select Type Flag
            setSelectTypeOptions([]); // Select Type
            setCategoryOptions([]); // Category
            setSelectedCategory([]); // Category
            setSelectedmodality([]); // Modality
            setModalityOptions([]); // Modality
            setItemsOptions([]); // Items
            setSelecteditems([]); // Items
            setSelectedProduct([]); //Select Type Options
            setSelectedBuyX([]); //Select Type Options
            setSelectedBuyY([]); //Select Type Options
        }
        if (flag == "3") { // Centres
            setSelectedCentreList([]); // Centres 
            setSelectedGender([]); // Gender 
            setGenderOptions([]); // Gender 
            setSelectedCustomerChannel([]); // Customer Channel 
            setCustomerChannelOptions([]); // Customer Channel 
            setCustomerProfileOptions([]); // Customer Profile 
            setSelectedCustomerProfile([]); // Customer Profile 
            setCustomerType("1"); // Customer Type
            setUsageOptions([]); // Usage
            setSelectedusage([]); // Usage
            setSelectedType([]); // Select Type   
            setSelectTypeValue(""); // Select Type Flag
            setSelectTypeOptions([]); // Select Type
            setCategoryOptions([]); // Category
            setSelectedCategory([]); // Category
            setSelectedmodality([]); // Modality
            setModalityOptions([]); // Modality
            setItemsOptions([]); // Items
            setSelecteditems([]); // Items
            setSelectedProduct([]); //Select Type Options
            setSelectedBuyX([]); //Select Type Options
            setSelectedBuyY([]); //Select Type Options
        }
        if (flag == "4") { // Gender
            setSelectedGender([]); // Gender 
            setSelectedCustomerChannel([]); // Customer Channel 
            setCustomerChannelOptions([]); // Customer Channel 
            setCustomerProfileOptions([]); // Customer Profile 
            setSelectedCustomerProfile([]); // Customer Profile 
            setCustomerType("1"); // Customer Type
            setUsageOptions([]); // Usage
            setSelectedusage([]); // Usage
            setSelectedType([]); // Select Type   
            setSelectTypeValue(""); // Select Type Flag
            setSelectTypeOptions([]); // Select Type
            setItemsOptions([]); // Items
            setSelecteditems([]); // Items
        }
        if (flag == "5") { // Customer Channel 
            setSelectedCustomerChannel([]); // Customer Channel 
            setCustomerProfileOptions([]); // Customer Profile 
            setSelectedCustomerProfile([]); // Customer Profile 
            setCustomerType("1"); // Customer Type
            setUsageOptions([]); // Usage
            setSelectedusage([]); // Usage
            setSelectedType([]); // Select Type   
            setSelectTypeValue(""); // Select Type Flag
            setSelectTypeOptions([]); // Select Type
        }
        if (flag == "6") { // Customer Profile 
            setSelectedCustomerProfile([]); // Customer Profile       
            setCustomerType("1"); // Customer Type
            setUsageOptions([]); // Usage
            setSelectedusage([]); // Usage
            setSelectedType([]); // Select Type  
            setSelectTypeValue(""); // Select Type Flag 
            setSelectTypeOptions([]); // Select Type
        }
        if (flag == "7") { // Usage
            setSelectedusage([]); // Usage
            setSelectedType([]); // Select Type 
            setSelectTypeValue(""); // Select Type Flag  
            setSelectTypeOptions([]); // Select Type
        }
        if (flag == "8") {
            setSelectedType([]); // Select Type 
            setSelectTypeValue(""); // Select Type Flag  
            setSelectedProduct([]); //Select Type Options
            setSelectedBuyX([]); //Select Type Options
            setSelectedBuyY([]); //Select Type Options
        }
        if (flag == "9") { // Category
            setSelectedCategory([]); // Category
            setSelectedmodality([]); // Modality
            setModalityOptions([]); // Modality
            setItemsOptions([]); // Items
            setSelecteditems([]); // Items
            setSelectedProduct([]); //Select Type Options
            setSelectedBuyX([]); //Select Type Options
            setSelectedBuyY([]); //Select Type Options
        }
        if (flag == "10") { // Modality
            setSelectedmodality([]); // Modality
            setItemsOptions([]); // Items
            setSelecteditems([]); // Items
            setSelectedProduct([]); //Select Type Options
            setSelectedBuyX([]); //Select Type Options
            setSelectedBuyY([]); //Select Type Options
        }
    }
    const handleSave = async () => {
        let TypeOptionDs1 = [];
        if (ruleName == "") { SweetAlert.fire("Please enter rule name."); return false; }
        if (selectedCustomerType.length == 0) { SweetAlert.fire("Please select customer type."); return false; }
        if (locationCustomerType.length == 0) { SweetAlert.fire("Please select region."); return false; }
        if (selectedCentreList.length == 0) { SweetAlert.fire("Please select centre."); return false; }
        if (selectedGender.length == 0) { SweetAlert.fire("Please select gender."); return false; }
        if (selectedCustomerChannel.length == 0) { SweetAlert.fire("Please select customer channel."); return false; }
        if (customerType == "0" && selectedCustomerProfile.length == 0) { SweetAlert.fire("Please select customer profile."); return false; }
        if (ageFrom.toString() == "") { SweetAlert.fire("Please enter age from."); return false; }
        if (!ageTo) { SweetAlert.fire("Please enter age to."); return false; }
        if (selectedcategory.length == 0) { SweetAlert.fire("Please select category."); return false; }
        if (selectedmodality.length == 0) { SweetAlert.fire("Please select modality."); return false; }
        if (selecteditems.length == 0) { SweetAlert.fire("Please select items."); return false; }
        if (minCartValue == "") { SweetAlert.fire("Please enter min cart value."); return false; }
        if (!applicabilityFrom) { SweetAlert.fire("Please enter applicability from date."); return false; }
        if (!applicabilityTo) { SweetAlert.fire("Please enter applicability to date."); return false; }
        //dateranges
        if (selectedusage.length == 0) { SweetAlert.fire("Please select usage."); return false; }
        if (couponName == "") { SweetAlert.fire("Please enter coupon name."); return false; }
        if (couponCount == "") { SweetAlert.fire("Please enter coupon count."); return false; }
        if (displayDescription == "") { SweetAlert.fire("Please enter display text."); return false; }
        if (selectedType.length == 0) { SweetAlert.fire("Please select coupon type."); return false; }
        if (selecttypevalue == "1") {
            if (selectedCartType.toLowerCase() == "fixed" || selectedCartType.toLowerCase() == "percentage") {
                if (cartValue == "") { SweetAlert.fire("Please enter value."); return false; }
            }
            if (selectedCartType.toLowerCase() == "percentage" && cartValue != "" && uptoCartValue == "") {
                SweetAlert.fire("Please enter upto value."); return false;
            }
        }
        if (selecttypevalue == "2") {
            if (selectedProduct.length == 0) { SweetAlert.fire("Please select product."); return false; }
        }
        if (selecttypevalue == "3") {
            if (selectedBuyX.length == 0) { SweetAlert.fire("Please select buy x."); return false; }
            if (selectedBuyY.length == 0) { SweetAlert.fire("Please select get y."); return false; }
        }
        if (customerType == "1" && selectedCustomerProfile.length == 0) {
            const TypeOptions1 = {
                'label': 'All',
                'value': '0',
                'disabled': false
            }
            TypeOptionDs1.push(TypeOptions1);
        }
        if (customerType == "1" && TypeOptionDs1.length == 0) { SweetAlert.fire("Customer type is not selected.Please refresh and try again."); return false; }
        try {
            const requestOptions = {
                CouponId: (localStorage.getItem("CouponId") == "" || localStorage.getItem("CouponId") == null || localStorage.getItem("CouponId") == undefined) ? "0" : localStorage.getItem("CouponId"),
                RuleName: ruleName.toString(),
                RuleDescription: ruleDescription ? ruleDescription.toString() : "",
                CustomerType: JSON.stringify(selectedCustomerType.map(({ value, label }) => ({ value, label }))),
                Region: JSON.stringify(locationCustomerType.map(({ value, label }) => ({ value, label }))),
                Centre: JSON.stringify(selectedCentreList.map(({ value, label }) => ({ value, label }))),
                Gender: JSON.stringify(selectedGender.map(({ value, label }) => ({ value, label }))),
                CustomerChannel: JSON.stringify(selectedCustomerChannel.map(({ value, label }) => ({ value, label }))),
                CustomerProfile: (customerType == "1" && selectedCustomerProfile.length == 0) ? JSON.stringify(TypeOptionDs1.map(({ value, label }) => ({ value, label }))) : JSON.stringify(selectedCustomerProfile.map(({ value, label }) => ({ value, label }))),
                AgeFrom: ageFrom.toString(),
                AgeTo: ageTo.toString(),
                Category: JSON.stringify(selectedcategory.map(({ value, label }) => ({ value, label }))),
                Modality: JSON.stringify(selectedmodality.map(({ value, label }) => ({ value, label }))),
                Items: JSON.stringify(selecteditems.map(({ value, label, ispackage }) => ({ value, label, ispackage }))),
                MinimumCartValue: minCartValue == undefined ? "0" : minCartValue.toString(),
                ApplicableFrom: applicabilityFrom.toString(),
                ApplicableTo: applicabilityTo.toString(),
                BlackoutDates: JSON.stringify(dateRanges),
                Usage: (selectedusage.value == undefined || selectedusage.value == null || selectedusage.value == "" ? selectedusage[0].value : selectedusage.value.toString()),
                CouponName: couponName.toString(),
                CouponCount: couponCount.toString(),
                DisplayDescription: displayDescription.toString(),
                CouponType: (selectedType.value == undefined || selectedType.value == null || selectedType.value == "" ? selectedType[0].value : selectedType.value.toString()),
                SelectedCouponType: selecttypevalue == "1" ? selectedCartType.toString() : "", // fixed, percentage or blank
                CartValue: selecttypevalue == "1" ? cartValue == undefined ? "0" : cartValue.toString() : "0",//either vaue or blank
                SelectProduct: JSON.stringify(selectedProduct.map(({ value, label, ispackage }) => ({ value, label, ispackage }))),
                BuyX: JSON.stringify(selectedBuyX.map(({ value, label, ispackage }) => ({ value, label, ispackage }))),
                GetY: JSON.stringify(selectedBuyY.map(({ value, label, ispackage }) => ({ value, label, ispackage }))),
                IsActive: (isActive == true ? "1" : isActive == false ? "0" : isActive),
                CreatedBy: LoginId,
                ShowOnScreenUI: showonui,
                UptoCartValue: uptoCartValue == undefined ? "0" : uptoCartValue == null ? "0" : uptoCartValue.toString()
            };
            let url = URL_Start + 'promotions/savepromotionscoupon'
            await axios.post(url, requestOptions).then((response) => {
                const data = response.data;
                if (data.Success) {
                    SweetAlert.fire({ title: 'Success', text: "Record saved successfully", icon: 'success', confirmButtonText: 'Ok', reverseButtons: false })
                        .then((result) => {
                            if (result.value) {
                                localStorage.removeItem('CouponId');
                                history.push({ pathname: `${process.env.PUBLIC_URL}/master/promotions`, search: `` });
                                window.location.reload(false);
                            }
                            else {
                                localStorage.removeItem('CouponId');
                                history.push({ pathname: `${process.env.PUBLIC_URL}/master/promotions`, search: `` });
                                window.location.reload(false);
                            }
                        })
                }
                else {
                    if (data.Data == null || data.Data == undefined || data.Data == "") { SweetAlert.fire("Some issue occured.Try again or check db logs"); }
                    else if (data.Data == "-2003") { SweetAlert.fire("You cannot decrease the coupon count because it is already applied"); }
                    else if (data.Data == "-2004") { SweetAlert.fire("Same coupon already exist"); }
                    else { SweetAlert.fire("Error is: " + data.Data); }
                    return false;
                }
            }).catch(function (error) { if (error.response) { ErrorFunction(error.response.status); } });
        }
        catch (error) { console.error("Outer catch error:", error); SweetAlert.fire({ title: "Server Inaccessible!", text: "You may not be connected to a network or Unable to connect to a server", icon: "error" }); }
    }
    const handleBack = async () => {
        localStorage.removeItem('CouponId');
        history.push({ pathname: `${process.env.PUBLIC_URL}/master/promotions`, search: `` });
    }
    const GetEditPromotionData = async (CouponId) => {
        try {
            let url = URL_Start + 'promotions/geteditpromotiondata/' + CouponId
            await axios.get(url).then((response) => {
                const data = response.data;
                if (data.Success) {
                    if (data.Data != null) {
                        const outputdata = data.Data;
                        glbldata = outputdata;
                        setRuleName(outputdata.RuleName);
                        setRuleDescription(outputdata.RuleDescription);
                        setAgeFrom(outputdata.AgeFrom);
                        setAgeTo(outputdata.AgeTo);
                        setMinCartValue(outputdata.MinimumCartValue);
                        setApplicabilityFrom(outputdata.ApplicableFrom.split(" ")[0]);
                        setApplicabilityTo(outputdata.ApplicableTo.split(" ")[0]);
                        setCouponName(outputdata.CouponName);
                        setCouponCount(outputdata.CouponCount);
                        setDisplayDescription(outputdata.DisplayDescription);
                        setIsActive(outputdata.IsActive);
                        if (data.Data.ShowOnScreenUI.toLowerCase() === "true" || data.Data.ShowOnScreenUI === "1") {
                            setShowonUI("1");
                            setIsyesShow(true);
                            setIsNoShow(false);
                        } else {
                            setShowonUI("0");
                            setIsyesShow(false);
                            setIsNoShow(true);
                        }
                        const selectedValues = outputdata.zblackoutdates.map((item) => ({
                            id: uuidv4(),
                            from: item.from.split(" ")[0],
                            to: item.to.split(" ")[0]
                        }));
                        setDateRanges(selectedValues);
                        setBlackoutFrom("");
                        setBlackoutTo("");
                    }
                    else { SweetAlert.fire("No data found"); }
                }
                else {
                    if (data.Data == null || data.Data == undefined || data.Data == "") { SweetAlert.fire("Some issue occured.Try again or check db logs"); }
                    else { SweetAlert.fire("Error is: " + data.Data); }
                    return false;
                }
            }).catch(function (error) { if (error.response) { ErrorFunction(error.response.status); } });
        }
        catch (error) { SweetAlert.fire({ title: "Server Inaccessible!", text: "You may not be connected to a network or Unable to connect to a server", icon: "error" }); }
    }
    const CheckShowonUI = (e) => { setShowonUI(e.target.value); }
    const CheckCustomerType = (e) => {
        if (e.target.value == "1") {
            setSelectedCustomerProfile([]);
            setCustomerProfileOptions([]);
        }
        setCustomerType(e.target.value);
    }
    const ErrorFunction = async (ErrorCode) => {
        if (ErrorCode == "400")
            SweetAlert.fire({ title: "Error 400", text: "Bad request", icon: "error" })
        else if (ErrorCode == "401")
            SweetAlert.fire({ title: "Error 401", text: "Unauthorized", icon: "error" })
        else if (ErrorCode == "403")
            SweetAlert.fire({ title: "Error 403", text: "Forbidden", icon: "error" })
        else if (ErrorCode == "404")
            SweetAlert.fire({ title: "Error 404", text: "Page not found", icon: "error" })
        else if (ErrorCode == "500")
            SweetAlert.fire({ title: "Error 500", text: "Internal Server Error", icon: "error" })
        else if (ErrorCode == "503")
            SweetAlert.fire({ title: "Error 503", text: "Service Unavailable", icon: "error" })
    }
    return (
        <Fragment>
            <Breadcrumb title="Promotions" parent="Master" />
            <Container fluid>
                <Row className="justify-content-center">
                    <Col md={12}>
                        <Card className="mt-3 shadow-sm">
                            <Card.Header className=" text-white">
                                <h5 className="mb-0">Promotion Details</h5>
                            </Card.Header>
                            <Card.Body>
                                <Row className="g-3">
                                    <Col md={6} lg={6}>
                                        <Form.Group>
                                            <Form.Label className="fw-bold">Rule Name <span className="text-red">* (100 characters allowed)</span></Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={ruleName}
                                                onChange={(e) => {
                                                    if (e.target.value.length <= 100) {
                                                        setRuleName(e.target.value);
                                                    }
                                                }}
                                                placeholder="Enter rule name"
                                            />
                                            <Form.Text className="text-muted">
                                                {ruleName.length} / 100 characters
                                            </Form.Text>
                                        </Form.Group>
                                    </Col>
                                    <Col md={6} lg={6}>
                                        <Form.Group>
                                            <Form.Label className="fw-bold">
                                                Rule Description <span className="text-red">(500 characters allowed)</span>
                                            </Form.Label>
                                            <Form.Control
                                                as="textarea"
                                                rows={3}
                                                className="border rounded"
                                                value={ruleDescription}
                                                onChange={(e) => {
                                                    if (e.target.value.length <= 500) {
                                                        setRuleDescription(e.target.value);
                                                    }
                                                }}
                                                placeholder="Enter rule description..."
                                            />
                                            <Form.Text className="text-muted">
                                                {ruleDescription.length} / 500 characters
                                            </Form.Text>
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                        <Card className="mt-3 shadow-sm">
                            <Card.Header className="text-white">
                                <h5 className="mb-0">Applicability</h5>
                            </Card.Header>
                            <Card.Body>
                                <Row className="g-3">
                                    <Col md={6}>
                                        <Form.Group>
                                            <Form.Label className="fw-bold">Customer Type <span className="text-red">*</span></Form.Label>
                                            <CentreDropdown
                                                centres={customerTypeOptions}
                                                selectedCentres={selectedCustomerType}
                                                onChange={ChangeCustomerType}
                                            />
                                        </Form.Group>
                                    </Col>
                                    {
                                        selectedCustomerType.length > 0 ?
                                            <Col md={6}>
                                                <Form.Group>
                                                    <Form.Label className="fw-bold">Region <span className="text-red">*</span></Form.Label>
                                                    <CentreDropdown
                                                        centres={locationTypeOptions}
                                                        selectedCentres={locationCustomerType}
                                                        onChange={ChangeRegion}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            :
                                            null
                                    }
                                    {
                                        locationCustomerType.length > 0 ?
                                            <>
                                                <Col md={6}>
                                                    <Form.Group>
                                                        <Form.Label>Centres <span className="text-red">*</span></Form.Label>
                                                        <CentreDropdown
                                                            centres={selectedCentreListOptions}
                                                            selectedCentres={selectedCentreList}
                                                            onChange={ChangeCentre}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col md={2} className="d-flex flex-column">
                                                    <div className="mt-auto">
                                                        <Button variant="primary" onClick={handleButtonClick} className="w-100 px-3 mb-4">
                                                            View Centres
                                                        </Button>
                                                    </div>
                                                </Col>
                                            </>
                                            :
                                            null
                                    }
                                </Row>
                                {
                                    selectedCentreList.length > 0 ?

                                        <Row className="g-3">
                                            <Col md={6}>
                                                <Form.Group>
                                                    <Form.Label className="fw-bold">Gender <span className="text-red">*</span></Form.Label>
                                                    <CentreDropdown
                                                        centres={genderOptions}
                                                        selectedCentres={selectedGender}
                                                        onChange={ChangeGender}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            {
                                                selectedGender.length > 0 ?
                                                    <Col md={6}>
                                                        <Form.Group>
                                                            <Form.Label className="fw-bold">Customer Channel <span className="text-red">*</span></Form.Label>
                                                            <CentreDropdown
                                                                centres={customerChannelOptions}
                                                                selectedCentres={selectedCustomerChannel}
                                                                onChange={ChangeCustomerChannel}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    :
                                                    null
                                            }
                                        </Row>
                                        :
                                        null
                                }
                                <Row className="g-3">
                                    {
                                        selectedCustomerChannel.length > 0 ?
                                            <>
                                                <Col md={6}>
                                                    <Form.Group className="mb-3 align-items-center animate-chk m-checkbox-inline">
                                                        <Form.Label>Profile Type <span className='text-red'>*</span></Form.Label>
                                                        <div className='mt-2'>
                                                            <Form.Label for="rd11">
                                                                <input class="radio_animated" type="radio" id='rd11' name="customertype" value="1" onChange={CheckCustomerType} checked={customerType === "1"} />All
                                                            </Form.Label>
                                                            <Form.Label for="rd21">
                                                                <input class="radio_animated" type="radio" id='rd21' name="customertype" value="0" onChange={CheckCustomerType} checked={customerType === "0"} />Profile
                                                            </Form.Label>
                                                        </div>
                                                    </Form.Group>
                                                </Col>
                                                {
                                                    customerType == "1" ? null :
                                                        <Col md={6}>
                                                            <Form.Group>
                                                                <Form.Label className="fw-bold">Customer Profile <span className="text-red">*</span></Form.Label>
                                                                <CentreDropdown
                                                                    centres={customerProfileOptions}
                                                                    selectedCentres={selectedCustomerProfile}
                                                                    onChange={ChangeCustomerProfile}
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                }
                                            </>
                                            :
                                            null
                                    }
                                    {/* {
                                        selectedCustomerChannel.length > 0 ?
                                            <Col md={6}>
                                                <Form.Group>
                                                    <Form.Label className="fw-bold">Customer Profile <span className="text-red">*</span></Form.Label>
                                                    <CentreDropdown
                                                        centres={customerProfileOptions}
                                                        selectedCentres={selectedCustomerProfile}
                                                        onChange={ChangeCustomerProfile}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            :
                                            null
                                    } */}
                                </Row>
                                <Row className="g-3">
                                    <Col md={6}>
                                        <Form.Group>
                                            <Form.Label className="fw-bold">Age From <span className="text-red">*</span></Form.Label>
                                            <Form.Control
                                                type="number"
                                                value={ageFrom}
                                                onChange={Changeagefrom}
                                                placeholder="Min age"
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group>
                                            <Form.Label className="fw-bold">Age To <span className="text-red">*</span></Form.Label>
                                            <Form.Control
                                                type="number"
                                                value={ageTo}
                                                onChange={Changeageto}
                                                onBlur={Changetodate}
                                                placeholder="Max age"
                                            />
                                        </Form.Group>
                                    </Col>
                                    {
                                        selectedCentreList.length > 0 ?
                                            <Col md={6}>
                                                <Form.Group>
                                                    <Form.Label className="fw-bold">Category <span className="text-red">*</span></Form.Label>
                                                    <CentreDropdown
                                                        centres={categoryOptions}
                                                        selectedCentres={selectedcategory}
                                                        onChange={handlecategoryChange}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            :
                                            null
                                    }
                                    {
                                        selectedcategory.length > 0 ?
                                            <Col md={6}>
                                                <Form.Group>
                                                    <Form.Label className="fw-bold">Modality <span className="text-red">*</span></Form.Label>
                                                    <CentreDropdown
                                                        centres={modalityOptions}
                                                        selectedCentres={selectedmodality}
                                                        onChange={handlemodalityChange}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            :
                                            null
                                    }
                                    {
                                        selectedmodality.length > 0 ?
                                            <>
                                                <Col md={6}>
                                                    <Form.Group>
                                                        <Form.Label className="fw-bold">Items <span className="text-red">*</span></Form.Label>
                                                        <CentreDropdown
                                                            centres={itemsOptions}
                                                            selectedCentres={selecteditems}
                                                            onChange={handleitemsChange}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col md={2} className="d-flex flex-column">
                                                    <div className="mt-auto">
                                                        <Button
                                                            variant="secondary"
                                                            onClick={handleButtonClick2}
                                                            className="w-100 px-3 mb-4"
                                                        >
                                                            View Items
                                                        </Button>
                                                    </div>
                                                </Col>
                                            </>
                                            :
                                            null
                                    }
                                </Row>
                                <Modal show={showItemsModal} onHide={() => setShowItemsModal(false)} size="lg" >
                                    <Modal.Header closeButton>
                                        <Modal.Title>View Items</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        {selecteditems.length > 0 ? (
                                            <div className="container mt-3">
                                                <InputGroup className="mb-3">
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Search items..."
                                                        value={searchQuery}
                                                        onChange={(e) => setSearchQuery(e.target.value)}
                                                    />
                                                    <InputGroup.Append>
                                                        <Button variant="secondary">
                                                            <i className="fa fa-search"></i>
                                                        </Button>
                                                    </InputGroup.Append>
                                                </InputGroup>
                                                <div
                                                    style={{
                                                        maxHeight: "400px",
                                                        overflowY: "auto",
                                                        overflowX: "hidden"
                                                    }}
                                                    className="table-striped"
                                                >
                                                </div>
                                                <div className="mt-2">
                                                    <DataTables
                                                        keyField="id"
                                                        tableData={filteredData}
                                                        columns={columns}
                                                        pagination={paginationFactory(paginationOptions)}
                                                    />
                                                </div>
                                            </div>
                                        ) : (
                                            <div
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center"
                                                }}
                                            >
                                                <p>No Items Selected.</p>
                                            </div>
                                        )}
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button variant="secondary" onClick={() => setShowItemsModal(false)}>
                                            Close
                                        </Button>
                                    </Modal.Footer>
                                </Modal>
                                <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" >
                                    <Modal.Header closeButton>
                                        <Modal.Title>View Centres</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        {selectedCentreList.length > 0 ? (
                                            <div className="container mt-3">
                                                <InputGroup className="mb-3">
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Search centres..."
                                                        value={searchQueryCentres}
                                                        onChange={(e) => setSearchQueryCentres(e.target.value)}
                                                    />
                                                    <InputGroup.Append>
                                                        <Button variant="secondary">
                                                            <i className="fa fa-search"></i>
                                                        </Button>
                                                    </InputGroup.Append>
                                                </InputGroup>
                                                <div style={{ maxHeight: "400px", overflowY: "auto", overflowX: "hidden", className: "table-striped", }}>
                                                    <DataTables
                                                        keyField="id"
                                                        tableData={filteredTableDataCentres}
                                                        columns={columns3}
                                                        pagination={paginationFactory(paginationOptions2)}
                                                    />
                                                </div>
                                            </div>
                                        ) : (
                                            <div
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center"
                                                }}
                                            >
                                                <p>No Centres Selected.</p>
                                            </div>
                                        )}
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button variant="secondary" onClick={() => setShowModal(false)}>
                                            Close
                                        </Button>
                                    </Modal.Footer>
                                </Modal>
                            </Card.Body >
                        </Card >
                        <Card Card className="mt-3" >
                            <Card.Header>
                                <h5>Rules</h5>
                            </Card.Header>
                            <Card.Body>
                                <Row>
                                    <Col md={6}>
                                        <Form.Group>
                                            <Form.Label>Min Cart Value <span className="text-red">*</span></Form.Label>
                                            <Form.Control
                                                type="number"
                                                value={minCartValue}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    //setMinCartValue(value === "" ? "" : Math.max(0, Number(value)));
                                                    if (value === "") {
                                                        setMinCartValue("");
                                                    }
                                                    else if (value == "0") {
                                                        setMinCartValue(value);
                                                    }
                                                    else {
                                                        const num = Number(value);
                                                        // Only allow non-negative numbers
                                                        if (!isNaN(num) && num >= 0) {
                                                            setMinCartValue(num);
                                                        }
                                                    }
                                                }}
                                                placeholder="Enter Min Cart Value"
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group className="mb-3 align-items-center animate-chk m-checkbox-inline">
                                            <Form.Label>Show On UI <span className='text-red'>*</span></Form.Label>
                                            <div className='mt-2'>
                                                <Form.Label for="rd1">
                                                    <input class="radio_animated" type="radio" id='rd1' name="shwonui" value="1" onChange={CheckShowonUI} checked={showonui === "1"} />Yes
                                                </Form.Label>
                                                <Form.Label for="rd2">
                                                    <input class="radio_animated" type="radio" id='rd2' name="shwonui" value="0" onChange={CheckShowonUI} checked={showonui === "0"} />No
                                                </Form.Label>
                                            </div>
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={6}>
                                        <Form.Group>
                                            <Form.Label>Applicability From <span className="text-red">*</span></Form.Label>
                                            <Form.Control
                                                type="date"
                                                value={applicabilityFrom}
                                                onChange={(e) => setApplicabilityFrom(e.target.value)}
                                                min={new Date().toISOString().split('T')[0]}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group>
                                            <Form.Label>Applicability To <span className="text-red">*</span></Form.Label>
                                            <Form.Control
                                                type="date"
                                                value={applicabilityTo}
                                                onChange={(e) => setApplicabilityTo(e.target.value)}
                                                min={new Date().toISOString().split('T')[0]}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={6}>
                                        <Form.Group>
                                            <Form.Label>Blackout Dates From</Form.Label>
                                            <Form.Control
                                                type="date"
                                                value={blackoutFrom}
                                                onChange={(e) => setBlackoutFrom(e.target.value)}
                                                min={new Date().toISOString().split('T')[0]}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group>
                                            <Form.Label>Blackout Dates To</Form.Label>
                                            <Form.Control
                                                type="date"
                                                value={blackoutTo}
                                                onChange={(e) => setBlackoutTo(e.target.value)}
                                                min={new Date().toISOString().split('T')[0]}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row className="justify-content-center">
                                    <Col md={4} className="d-flex justify-content-center align-items-end mb-4 mt-2">
                                        <Button variant="primary" onClick={handleAddDateRange}>
                                            + Add Blackout Date Range
                                        </Button>
                                    </Col>
                                </Row>
                                {dateRanges.length > 0 && (
                                    <Row>
                                        <Col>
                                            <div style={{ maxHeight: "250px", overflowY: "auto", overflowX: "hidden", width: "100%", className: "table-striped" }}>
                                                <DataTables
                                                    keyField="id"
                                                    tableData={dateRanges}
                                                    columns={columns2}
                                                    pagination={paginationFactory(paginationOptions1)}
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                )}
                            </Card.Body>
                        </Card >
                        <Card Card className="mt-3" >
                            <Card.Header>
                                <h5>Coupon Usage</h5>
                            </Card.Header>
                            <Card.Body>
                                {
                                    selectedCustomerProfile.length > 0 || customerType == "1" ?
                                        <Row className="gy-3">
                                            <Col md={6}>
                                                <Form.Group>
                                                    <Form.Label>Usage <span className="text-red">*</span></Form.Label>
                                                    <UserDropdown
                                                        users={usageOptions}
                                                        selectedUser={selectedusage}
                                                        onChange={ChangeUsage}
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        :
                                        null
                                }
                                <Row className="gy-3">
                                    <Col md={6}>
                                        <Form.Group>
                                            <Form.Label>Coupon Name <span className="text-red">* (100 characters allowed)</span></Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={couponName}
                                                onChange={(e) => {
                                                    const valueWithoutSpaces = e.target.value.replace(/\s/g, '');
                                                    if (valueWithoutSpaces.length <= 100) {
                                                        setCouponName(valueWithoutSpaces);
                                                    }
                                                }}
                                            />
                                            <Form.Text className="text-muted">
                                                {couponName.length} / 100 characters
                                            </Form.Text>
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group>
                                            <Form.Label>Coupon Count <span className="text-red">*</span></Form.Label>
                                            <Form.Control
                                                type="number"
                                                value={couponCount}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    setCouponCount(value === "" ? "" : Math.max(0, Number(value)));
                                                }}
                                                placeholder="Enter coupon count"
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={12}>
                                        <Form.Group>
                                            <Form.Label>
                                                Display Text <span className="text-red">* (500 characters allowed)</span>
                                            </Form.Label>
                                            <Form.Control
                                                as="textarea"
                                                rows={3}
                                                value={displayDescription}
                                                onChange={(e) => {
                                                    if (e.target.value.length <= 500) {
                                                        setDisplayDescription(e.target.value);
                                                    }
                                                }}
                                            />
                                            <Form.Text className="text-muted">
                                                {displayDescription.length} / 500 characters
                                            </Form.Text>
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                        {
                            selectedusage != [] ?
                                <Card Card className="mt-3" >
                                    <Card.Header>
                                        <h5>Coupon Type</h5>
                                    </Card.Header>
                                    <Card.Body>
                                        <Row className="gy-3">
                                            <Col md={6}>
                                                <Form.Group>
                                                    <Form.Label>Select Type <span className="text-red">*</span></Form.Label>
                                                    <UserDropdown
                                                        users={selecttypeOptions}
                                                        selectedUser={selectedType}
                                                        onChange={ChangeType}
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row className="gy-3">
                                            {selecttypevalue === "1" && (
                                                <>
                                                    <Col md={6}>
                                                        <Form.Group>
                                                            <Form.Label>Cart Value Type <span className="text-red">*</span></Form.Label>
                                                            <Form.Control
                                                                as="select"
                                                                value={selectedCartType}
                                                                onChange={(e) => {
                                                                    setSelectedCartType(e.target.value);
                                                                    setCartValue("");
                                                                    setUptoCartValue("");
                                                                }}
                                                            >
                                                                <option value="">Select Type</option>
                                                                <option value="percentage">Percentage (Upto)</option>
                                                                <option value="fixed">Fixed Value</option>
                                                            </Form.Control>
                                                        </Form.Group>
                                                    </Col>
                                                    {selectedCartType && (
                                                        <Col md={6}>
                                                            <Form.Group>
                                                                <Form.Label>Enter Value <span className="text-red">*</span></Form.Label>
                                                                <InputGroup>
                                                                    {selectedCartType === "fixed" && <InputGroup.Text>₹</InputGroup.Text>}
                                                                    <Form.Control
                                                                        type="number"
                                                                        value={cartValue}
                                                                        onChange={(e) => {
                                                                            let value = e.target.value;
                                                                            if (value === "") {
                                                                                setCartValue("");
                                                                                setUptoCartValue("");
                                                                            } else {
                                                                                if (selectedCartType === "percentage") {
                                                                                    value = Math.min(100, Math.max(1, Number(value)));
                                                                                } else if (selectedCartType === "fixed") {
                                                                                    value = Math.max(1, Number(value));
                                                                                }
                                                                                setCartValue(value);
                                                                            }
                                                                        }}
                                                                        min="1"
                                                                        max={selectedCartType === "percentage" ? "100" : undefined}
                                                                    />
                                                                    {selectedCartType === "percentage" && <InputGroup.Text>%</InputGroup.Text>}
                                                                </InputGroup>
                                                            </Form.Group>
                                                        </Col>
                                                    )}
                                                    {cartValue && selectedCartType === "percentage" && (
                                                        <Col md={6}>
                                                            <Form.Group>
                                                                <Form.Label>Enter Upto Value <span className="text-red">*</span></Form.Label>
                                                                <InputGroup>
                                                                    <InputGroup.Text>₹</InputGroup.Text>                                                                    <Form.Control
                                                                        type="number"
                                                                        value={uptoCartValue}
                                                                        onChange={(e) => {
                                                                            let value = e.target.value;
                                                                            if (selectedCartType === "percentage" && cartValue > 0) {
                                                                                if (value !== "") {
                                                                                    value = Math.max(1, Number(value));
                                                                                }
                                                                            }
                                                                            setUptoCartValue(value || "");
                                                                        }}
                                                                        min="1"
                                                                    />
                                                                </InputGroup>
                                                            </Form.Group>
                                                        </Col>
                                                    )}
                                                </>
                                            )}
                                            {selecttypevalue === "2" && (
                                                <Col md={6}>
                                                    <Form.Group>
                                                        <Form.Label>Free Product <span className="text-red">*</span></Form.Label>
                                                        {
                                                            selecteditems.length > 0 ?
                                                                <>
                                                                    <CentreDropdown
                                                                        centres={itemsOptions.filter(option =>
                                                                            !selecteditems.some(selected => selected.value === option.value)
                                                                        )}
                                                                        selectedCentres={selectedProduct}
                                                                        onChange={ChangeProduct}
                                                                    />
                                                                </> :
                                                                <CentreDropdown
                                                                    centres={itemsOptions}
                                                                    selectedCentres={selectedProduct}
                                                                    onChange={ChangeProduct}
                                                                />
                                                        }
                                                    </Form.Group>
                                                </Col>
                                            )}
                                            {selecttypevalue === "3" && (
                                                <>
                                                    <Col md={6}>
                                                        <Form.Group>
                                                            <Form.Label>Buy X <span className="text-red">*</span></Form.Label>
                                                            {
                                                                selecteditems.length > 0 ?
                                                                    <>
                                                                        <CentreDropdown
                                                                            centres={itemsOptions.filter(option =>
                                                                                !selecteditems.some(selected => selected.value === option.value)
                                                                            )}
                                                                            selectedCentres={selectedBuyX}
                                                                            onChange={handleBuyXChange}
                                                                        />
                                                                    </> :
                                                                    <CentreDropdown
                                                                        centres={itemsOptions}
                                                                        selectedCentres={selectedBuyX}
                                                                        onChange={handleBuyXChange}
                                                                    />
                                                            }
                                                        </Form.Group>
                                                    </Col>
                                                    {selectedBuyX.length > 0 && (
                                                        <Col md={6}>
                                                            <Form.Group>
                                                                <Form.Label>Get Y Free<span className="text-red">*</span></Form.Label>
                                                                {
                                                                    selecteditems.length > 0 ?
                                                                        <>
                                                                            <CentreDropdown
                                                                                centres={itemsOptions.filter(option =>
                                                                                    !selecteditems.some(selected => selected.value === option.value)
                                                                                )}
                                                                                selectedCentres={selectedBuyY}
                                                                                onChange={handleBuyYChange}
                                                                            />
                                                                        </>
                                                                        :
                                                                        <CentreDropdown
                                                                            centres={itemsOptions}
                                                                            selectedCentres={selectedBuyY}
                                                                            onChange={handleBuyYChange}
                                                                        />
                                                                }
                                                            </Form.Group>
                                                        </Col>
                                                    )}
                                                </>
                                            )}
                                        </Row>
                                        <Col md={12} className='text-center mt-3'>
                                            <Form.Group>
                                                <Form.Label for="isActive" className="mr-2">
                                                    <input className="checkbox_animated mr-3" type="checkbox" id='isActive' checked={isActive} name="isActive" value="All" onChange={(e) => setIsActive(e.target.checked)} />Is Active
                                                </Form.Label>
                                                <Button variant='primary' className="mr-2" onClick={handleSave}>Save</Button>
                                                <Button variant='secondary' className="mr-2" onClick={handleBack}>Back</Button>
                                                <Button variant='primary' className="mr-2" onClick={handleCopyCoupon}> Copy Coupon Code</Button>
                                                <Button variant='secondary' className="mr-2" onClick={handleRefresh}>Refresh</Button>
                                            </Form.Group>
                                        </Col>
                                    </Card.Body>
                                </Card>
                                :
                                null
                        }
                    </Col>
                </Row>
            </Container>
        </Fragment >
    );
};

export default AddCoupon;
